module.exports = __webpack_public_path__ + "img/动态礼物--大图gif.1e8e2d26.gif";